import '../styles/Common.css';
import '../styles/About.css';
import {useTranslation, Trans} from "react-i18next";
import {Helmet} from 'react-helmet-async';
import SEO from "./SEO";
import heroBackgroundImage from '../assets/images/hero_background/about_hero_bg_original4.jpg';


const Departments = () => {
    const {t, i18n} = useTranslation(['departments', 'common', 'title'])
    const isChinese = i18n.language.includes('zh'); 
    const leaders = t('departments', {ns: 'departments', returnObjects: true});
    const core_research_fellows = t('core_research_fellows', {ns: 'departments', returnObjects: true});

    return (
        <div className={"bg-white"}>
            <SEO title={t('departments', {ns: 'html_title'})}></SEO>
            <div className={"bg-cover bg-white bg-blend-hard-light bg-bottom bg-no-repeat min-h-[350px] sm:min-h-[400px] w-full flex flex-col justify-start items-center p-6"}
                 style={{backgroundImage: `url(${heroBackgroundImage})`}}
            >
                <div className={"flex flex-col justify-center items-start max-w-[900px] mt-36 mb-16"}>
                    <div className={`font-bold tracking-[.02em] text-white leading-normal ${isChinese ? 'text-4xl sm:text-[3.5rem] sm:tracking-[.05em]' : 'text-4xl sm:text-[3rem] sm:tracking-[.02em]'}`}>
                        {t('hero_heading_1')}
                    </div>
                </div>
            </div>
            <div className={"content-container py-24"}>
                <div className={"flex flex-col justify-center items-center max-w-6xl mx-auto px-6 sm:px-12 pb-36 rounded-3xl bg-cover bg-white bg-blend-multiply bg-center-top bg-no-repeat"}>
                    {leaders && leaders.map((person, index) => (
                        <div key={index} className="border-b-4 border-[#c00000] w-full md:w-[600px] lg:w-[750px] mb-16 px-8 py-12 flex flex-col md:flex-row justify-start items-center bg-gray-50 shadow-lg">
                            <div className="flex flex-col items-center sm:items-start lg:max-w-[100%]">
                                {/*<p className="mb-5 text-[#c00000] font-semibold text-center sm:text-start">{person.name}</p>*/}
                                <h3 className="text-3xl font-medium text-[#c00000] mb-9">{person.name}</h3>
                                <ul className="text-gray-600 text-xl">
                                    {person.description.map((title, idx) => (
                                        <li key={idx}>{title}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))
                    }
                </div>
            </div>
        </div>
    );
};

export default Departments;